import { getters } from "@/vuex/auth/getters";
import { RootState } from "@/vuex/types";
import { Module } from "vuex";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { state } from "./state";
import { AuthState } from "./types";

const namespaced: boolean = true;

type AuthModule = Module<AuthState, RootState>;

export const authModule: AuthModule = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
